// This is a simple JavaScript code to toggle the visibility of a drawer menu
$(document).ready(function () {
  $("#toggleBtn").on("click", function () {
    $("#drawer").toggleClass("active");
  });
  $("#closebtn").on("click", function () {
    $("#drawer").removeClass("active");
  });
});

$(document).ready(function () {
  $(".popular-categories-slider").slick({
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true, // This allows the use of custom arrows
    prevArrow: $(".slick-prev"), // Custom Previous Button
    nextArrow: $(".slick-next"), // Custom Next Button
    infinite: true,
    responsive: [
      {
        breakpoint: 1024, // Tablets and above (1024px and above)
        settings: {
          slidesToShow: 8, // Show 3 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 950, // Tablets (below 1024px)
        settings: {
          slidesToShow: 8, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 800, // Tablets (below 1024px)
        settings: {
          slidesToShow: 7, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 768, // Tablets (below 1024px)
        settings: {
          slidesToShow: 6, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 480, // Phones (below 768px)
        settings: {
          slidesToShow: 3, // Show 1 slide
          slidesToScroll: 1,

          arrows: true,
        },
      },
    ],
  });

  $(".shop-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    fade: true,
    appendDots: $(".custom-slider-dots"), // Use your custom dots container
    customPaging: function (slider, i) {
      return '<button class="custom-dot">' + (i + 1) + "</button>";
    },
    arrows: true,
    prevArrow: $(".shop-slick-prev"),
    nextArrow: $(".shop-slick-next"),
    infinite: true,
  });

  $(".popular-products-slider").slick({
    slidesToShow: 6,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    appendDots: $(".popular-slider-dots"), // Use your custom dots container
    customPaging: function (slider, i) {
      return '<button class="popular-custom-dot">' + (i + 1) + "</button>";
    },
    arrows: true,
    prevArrow: $(".popular-prev"), // Custom Previous Button
    nextArrow: $(".popular-next"), // Custom Next Button

    infinite: true,
    responsive: [
      {
        breakpoint: 1024, // Tablets and above (1024px and above)
        settings: {
          slidesToShow: 5, // Show 3 slides
          slidesToScroll: 4,

          arrows: true,
        },
      },
      {
        breakpoint: 950, // Tablets (below 1024px)
        settings: {
          slidesToShow: 4, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 800, // Tablets (below 1024px)
        settings: {
          slidesToShow: 3, // Show 2 slides
          slidesToScroll: 3,

          arrows: true,
        },
      },
      {
        breakpoint: 768, // Tablets (below 1024px)
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 2,

          arrows: true,
        },
      },
      {
        breakpoint: 480, // Phones (below 768px)
        settings: {
          slidesToShow: 1, // Show 1 slide
          slidesToScroll: 1,
          dots: false,
          arrows: true,
        },
      },
    ],
  });

  $(".popular-brands-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true,
    prevArrow: $(".popular-brands-slick-prev"), // Custom Previous Button
    nextArrow: $(".popular-brands-slick-next"), // Custom Next Button
    infinite: true,
    responsive: [
      {
        breakpoint: 1024, // Tablets and above (1024px and above)
        settings: {
          slidesToShow: 3, // Show 3 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 950, // Tablets (below 1024px)
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 800, // Tablets (below 1024px)
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 768, // Tablets (below 1024px)
        settings: {
          slidesToShow: 1, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
    ],
  });

  // $(".explore-creators-slider").slick({
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   dots: false,
  //   arrows: true,
  //   prevArrow: $(".explore-creators-slick-prev"), // Custom Previous Button
  //   nextArrow: $(".explore-creators-slick-next"), // Custom Next Button
  //   infinite: true,
  //   responsive: [
  //     {
  //       breakpoint: 1024, // Tablets and above (1024px and above)
  //       settings: {
  //         slidesToShow: 5, // Show 3 slides
  //         slidesToScroll: 1,

  //         arrows: true,
  //       },
  //     },
  //     {
  //       breakpoint: 950, // Tablets (below 1024px)
  //       settings: {
  //         slidesToShow: 3, // Show 2 slides
  //         slidesToScroll: 1,

  //         arrows: true,
  //       },
  //     },
  //     {
  //       breakpoint: 800, // Tablets (below 1024px)
  //       settings: {
  //         slidesToShow: 2, // Show 2 slides
  //         slidesToScroll: 1,

  //         arrows: true,
  //       },
  //     },
  //     {
  //       breakpoint: 768, // Tablets (below 1024px)
  //       settings: {
  //         slidesToShow: 1, // Show 2 slides
  //         slidesToScroll: 1,

  //         arrows: true,
  //       },
  //     },
  //   ],
  // });

  $(".slider-gifts").slick({
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true, // This allows the use of custom arrows
    prevArrow: $(".gifts-prev"), // Custom Previous Button
    nextArrow: $(".gifts-next"), // Custom Next Button
    infinite: true,
    responsive: [
      {
        breakpoint: 1024, // Tablets and above (1024px and above)
        settings: {
          slidesToShow: 8, // Show 3 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 950, // Tablets (below 1024px)
        settings: {
          slidesToShow: 8, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 800, // Tablets (below 1024px)
        settings: {
          slidesToShow: 7, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 768, // Tablets (below 1024px)
        settings: {
          slidesToShow: 6, // Show 2 slides
          slidesToScroll: 1,

          arrows: true,
        },
      },
      {
        breakpoint: 480, // Phones (below 768px)
        settings: {
          slidesToShow: 3, // Show 1 slide
          slidesToScroll: 1,

          arrows: true,
        },
      },
    ],
  });
});

$(document).ready(function () {
  // Tab Switching Logic
  $(".tab-title").click(function () {
    var tabId = $(this).data("tab");

    // Hide all tab content and remove active class from all tab titles
    $(".tab-pane").removeClass("active");
    $(".tab-title").removeClass("active");

    // Show active content and activate the corresponding tab title
    $("#" + tabId).addClass("active");
    $(this).addClass("active");

    // Re-initialize the slick slider in case the tab content was hidden before
    if ($("#" + tabId).find(".slider-wishlist").length) {
      $(".slider-wishlist").slick("setPosition");
    }
    if ($("#" + tabId).find(".slider-gifts").length) {
      $(".slider-gifts").slick("setPosition");
    }
  });
});

$(document).ready(function () {
  // Open the modal when a button is clicked
  $(".open-modal").click(function () {
    var modalId = $(this).data("modal"); // Get the modal ID from the data-modal attribute
    $("#" + modalId).fadeIn(); // Show the modal
    setTimeout(function () {
      $(window).trigger("resize");
    }, 100);
  });

  // Close the modal when the close button is clicked
  $(".close, .close-modal").click(function () {
    var modalId = $(this).data("modal"); // Get the modal ID from the close button's data-modal attribute
    $("#" + modalId).fadeOut(); // Hide the modal
  });
  $(document).on("click", ".close-modal", function () {
    console.log("close-modal clicked");
    $(this).parents(".modal").first().fadeOut(); // Hide the modal
  });

  // Close the modal when clicking anywhere outside the modal content
  $(window).click(function (event) {
    if ($(event.target).hasClass("modal")) {
      $(".modal").fadeOut(); // Close the modal if clicked outside
    }
  });
});

$(document).ready(function () {
  // Initialize the main slider
});
$.fn.loading = function (status) {
  if (status === true) {
    const spinner = `
          <div class="custom-block-spinner-bar">
          <div class="spinner-border text-primary d-inline-block" role="status">
              <span class="visually-hidden">Loading...</span>
          </div>
          </div>

      `;
    $(this).addClass("position-relative");
    $(this).append(spinner);
  } else {
    $(this).removeClass("position-relative");
    $(this).find(".custom-block-spinner-bar").remove();
  }
  return $(this);
};

function showToast(title, message, type = "info", duration = 5000) {
  let toastContainer = $("#toast-container");

  // If toast container does not exist, create it
  if (toastContainer.length === 0) {
    $("body").append('<div id="toast-container"></div>');
    toastContainer = $("#toast-container");

    // Apply container styles
    toastContainer.css({
      position: "fixed",
      top: "20px",
      right: "20px",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    });
  }

  // Toast style variants
  const typeStyles = {
    success: { background: "#fff", color: "#1b1b1b", border: "#fff" },
    error: { background: "#fff", color: "#1b1b1b", border: "#fff" },
    warning: { background: "#fff", color: "#1b1b1b", border: "#fff" },
    info: { background: "#fff", color: "#1b1b1b", border: "#fff" },
  };

  const style = typeStyles[type] || typeStyles.info;

  let toastId = "toast-" + new Date().getTime();

  const toastHTML = `
    <div id="${toastId}" class="custom-toast ${type}" >
    <div class="toast-icon">
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.2503 0C5.48467 0 0 5.48467 0 12.2503C0 19.016 5.48465 24.5006 12.2503 24.5006C19.016 24.5006 24.5006 19.016 24.5006 12.2503C24.5006 5.48467 19.016 0 12.2503 0ZM19.4167 8.72297L10.5122 17.513L4.98605 12.1264L6.73596 10.2644L10.5138 14.0423L17.6528 6.90314L19.4167 8.72297Z" fill=""/>
    </svg>
    </div> 
    <div class="toast-content">
      <strong>${title}</strong><span class="toast-message">${message}</span>
      <span class="close-btn">&times;</span>
      </div>
    </div>
  `;

  toastContainer.append(toastHTML);

  const toast = $("#" + toastId);
  toast.css({
    padding: "12px 16px",
    minWidth: "250px",
    maxWidth: "320px",
    backgroundColor: style.background,
    color: style.color,
    border: `1px solid ${style.border}`,
    borderRadius: "6px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    position: "relative",
    fontSize: "14px",
    fontFamily: "inherit",
  });

  toast
    .find(".close-btn")
    .css({
      position: "absolute",
      top: "4px",
      right: "8px",
      cursor: "pointer",
      fontSize: "18px",
    })
    .on("click", function () {
      toast.fadeOut(300, () => toast.remove());
    });

  setTimeout(() => {
    toast.fadeOut(300, () => toast.remove());
  }, duration);
}
function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      document.getElementById("cart-badge").innerText = cart.item_count;
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

$(document).ready(function () {
  $("#copy-btn").on("click", function () {
    const $copyText = $("#copy-link");
    $copyText.select();
    $copyText[0].setSelectionRange(0, 99999); // For mobile devices

    // Use clipboard API if available
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText($copyText.val())
        .then(() => {
          alert("Link copied to clipboard!");
        })
        .catch((err) => {
          alert("Failed to copy link.");
          console.error(err);
        });
    } else {
      // Fallback for older browsers
      document.execCommand("copy");
      alert("Link copied (fallback).");
    }
  });
});
